import "date-fns";
import React, { Component } from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { connect } from "react-redux";
import MomentUtils from "@date-io/moment";

class MaterialUIPickers extends Component {
  static defaultProps = {
    dateValue: new Date(),
    onChangeDate: () => alert("Date has been changed!"),
  };
  render() {
    const language = this.props.language;
    return (
      <MuiPickersUtilsProvider
        utils={MomentUtils}
        locale={language == "english" ? "en" : "ar"}
      >
        <KeyboardDatePicker
          dir={language == "english" ? "ltr" : "rtl"}
          margin="normal"
          className="w-100 mt-0"
          id="date-picker-dialog"
          okLabel={language == "english" ? "Ok" : "تم"}
          cancelLabel={language == "english" ? "Cancel" : "الغاء"}
          label={
            language == "english" ? "Enter your birthday" : "ادخل تاريخ ميلادك"
          }
          InputLabelProps={{
            style: {
              transformOrigin: language == "english" ? "top left" : "top right",
              right: language == "arabic" ? 0 : "unset",
              left: language == "english" ? 0 : "unset",
            },
          }}
          KeyboardButtonProps={{
            style: {
              padding: "0px !important",
            },
          }}
          format={language == "english" ? "DD/MM/YYYY" : "YYYY/MM/DD"}
          value={this.props.dateValue}
          onChange={this.props.onChangeDate}
          KeyboardButtonProps={{
            style: {
              left: language == "arabic" && -15,
              right: language == "english" && -5,
            },
          }}
        />
      </MuiPickersUtilsProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

export default connect(mapStateToProps)(MaterialUIPickers);
